import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncFaq({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/faq"));
  console.log("Loading", AsyncFaq.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncFaq;
